<template>
  <el-drawer :visible.sync="drawer" size="65%" title="Asignar usuarios a rol">
    <el-container>
      <el-main>
        <el-row>
          <el-col>
            <el-form ref="form" :model="currentRole" label-width="90px">
              <el-form-item label="Rol">
                <el-input v-model="currentRole.RolName" disabled></el-input>
              </el-form-item>

              <el-form-item label-width="0">
                <div class="flex reverse align-flex-end">
                  <el-button
                    class="box"
                    size="mini"
                    type="success"
                    icon="el-icon-plus"
                    @click="showAssigner"
                    >Agregar usuario</el-button
                  >
                </div>
              </el-form-item>

              <el-form-item label-width="0">
                <el-table
                  :data="filterData"
                  style="width: 100%"
                  height="550"
                  v-loading="loading"
                >
                  <el-table-column width="60" fixed align="center">
                    <template slot="header" slot-scope="scope">
                      <i class="el-icon-setting" :key="scope.$index"></i>
                    </template>
                    <template slot-scope="scope">
                      <el-button
                        icon="el-icon-minus"
                        circle
                        size="mini"
                        type="danger"
                        :key="scope.$index"
                        @click="removeUser(scope.row)"
                      ></el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="FullName"
                    label="Nombre"
                    min-width="200"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="UserName"
                    label="Usuario"
                    min-width="150"
                  />
                </el-table>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-main>
    </el-container>

    <DrawerAssignerUserRole ref="assigner_user" />
  </el-drawer>
</template>

<script>
import DrawerAssignerUserRole from "@/components/role_manager/DrawerAssignerUserRole";

export default {
  name: "DrawerRoleViewUsers",
  components: {
    DrawerAssignerUserRole
  },
  data() {
    return {
      keySearch: "FullName",
      loading: false,
      innerDrawer: false,
      form: {
        search: null
      },
      drawer: false,
      currentRole: {},
      users: []
    };
  },
  computed: {
    filterData() {
      var filterable = [];
      let getTypeParams = typeof this.form.search;
      if (getTypeParams != "object") {
        if (this.form.search.trim().length == 0) {
          // input filter with blanck value
          filterable = this.users;
        } else {
          if (this.form.search !== null) {
            filterable = this.users.filter((data) => {
              const value = data[this.keySearch];
              const valueType = typeof value;

              if (valueType === "number") {
                return value.toString() === this.form.search;
              }

              return (
                !this.form.search ||
                data[this.keySearch]
                  .toLowerCase()
                  .includes(this.form.search.toLowerCase())
              );
            });
          } else {
            filterable = this.users;
          }
        }
      } else {
        filterable = this.users;
      }

      return filterable;
    }
  },
  methods: {
    removeUser(user) {
      this.$http
        .delete("/api/rolmanager/deleteforuser", {
          data: {
            RolID: this.currentRole.RolId,
            UserID: user.Id
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getAllUser() {
      this.loading = false;

      this.$http
        .get("/api/rolmanager/getRolById", {
          params: {
            "criteria.rolID": this.currentRole.RolId
          }
        })
        .then((resp) => {
          this.users = resp.data[0].Users;
        })
        .catch(() => {
          this.$message.error("Error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    show(role) {
      this.currentRole = role;
      this.getAllUser();
      this.drawer = true;
    },
    showAssigner() {
      this.$refs.assigner_user.currentRole = this.currentRole;
      this.$refs.assigner_user.append = true;
      this.$refs.assigner_user.drawer = true;
    }
  }
};
</script>

<style></style>
